import React, { Suspense } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { professionalAction } from "../../_actions";
import { faceSearchAction } from "../../_actions/face.search.service";
import {
  Drawer,
  Button,
  Divider,
  PageHeader,
  Descriptions,
  message,
} from "antd";
import { FaceSearchAllocationForm } from "./FaceSearchAllocationForm";

const FaceSearchListTable = React.lazy(() =>
  import("./faceSearchList").then((module) => ({
    default: module.FaceSearchListTable,
  }))
);

let columns = [];
let data = [];

class FaceSearchAllocation extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    addFaceSearchAllocation: false,
    isUpdate: false,
    userFormEditData: [],
    resetFrom: false,
    userList: [],
    units: "",
    data: [],
    columns: [],
  };
  userForm = React.createRef();

  componentDidMount() {
    this.getActiveUnits();
    this.getAllocatedFaceSearchAllocationList();
  }

  onOpenAddFaceSearchAllocationDrawer = () => {
    this.setState({
      addFaceSearchAllocation: true,
      resetFrom: true,
    });
  };

  onCloseAddFaceSearchAllocationDrawer = () => {
    this.setState({
      addFaceSearchAllocation: false,
      resetFrom: false,
    });
  };

 

  getActiveUnits = () => {
    professionalAction
      .getActiveCities()
      .then((res) => {
        res &&
          res.text().then((response) => {
            let units = JSON.parse(response);
            this.setState({ units: units });
          });
      })
      .catch((err) => {});
  };

  getCityName = (id) => {
    const { pc_cities } = this.props;
    if (pc_cities && pc_cities.length) {
      const city = _.find(pc_cities, { id });
      return city ? city.City : "";
    }
  };

  getAllocatedFaceSearchAllocationList = () => {
    faceSearchAction
      .getFaceSearchAllocation()
      .then((result) => {
        this.setState({ data: result || [] });
      })
      .catch((error) => {
        console.error("Error fetching face search allocation list:", error);
      });
  };

  onFormFinish = (values) => {
    const requestData = {
      cityId: values.cityId,
      name: values.name,
      status: true,
    };

    faceSearchAction
      .saveFaceSearchAllocation(requestData)
      .then(() => {
        message.success("Successfully Submitted");
        this.onCloseAddFaceSearchAllocationDrawer();
        this.getAllocatedFaceSearchAllocationList();
      })
      .catch((error) => {
        console.error("Error in saving face search allocation:", error);
      });
  };

  
  render() {
    const { users } = this.props;
    const { user } = this.props;
    const { pc_cities, basicDistricts } = this.props;

    const roleFour = user && user.role === "4" ? "घटक" : "जिल्हा";

    return (
      <div className="col-md-6 col-md-offset-3">
        <div className="site-page-header-ghost-wrapper">
          <PageHeader
            ghost={false}
            onBack={false}
            title={user && user.userid}
            subTitle={
              user && user.role === "4" ? "( ADMIN )" : "( SUPER ADMIN )"
            }
            extra={[
              <Button
                type="primary"
                className="mb-4"
                onClick={this.onOpenAddFaceSearchAllocationDrawer}
              >
                नवीन जोडा
              </Button>,
            ]}
          >
            <Descriptions size="small" column={3}>
              <Descriptions.Item
                label={user && user.role === "8" ? "राज्य" : roleFour}
              >
                {user && user.role === "8"
                  ? "महाराष्ट्र"
                  : "महाराष्ट्र" +
                    " " +
                    "( " +
                    this.getCityName(user && user.cityId) +
                    " )"}
              </Descriptions.Item>
              <Descriptions.Item>
                <span style={{ fontSize: "25px", fontWeight: "600" }}>
                  Face Search Allocation
                </span>
              </Descriptions.Item>
            </Descriptions>
          </PageHeader>
        </div>

        <Divider />
        <Drawer
          title="नवीन जोडा"
          placement="right"
          width={720}
          closable={true}
          onClose={this.onCloseAddFaceSearchAllocationDrawer}
          visible={this.state.addFaceSearchAllocation}
          footer={
            <div
              style={{
                textAlign: "right",
              }}
            >
              <Button
                onClick={this.onCloseAddFaceSearchAllocationDrawer}
                style={{ marginRight: 8 }}
              >
                Cancel
              </Button>
              
            </div>
          }
        >
          <FaceSearchAllocationForm
            ref={this.userForm}
            user={user}
            data={this.state.data}
            units={this.state.units}
            addFaceSearchAllocation={this.state.addFaceSearchAllocation}
            onFormFinish={this.onFormFinish}
          ></FaceSearchAllocationForm>
        </Drawer>
        <Suspense fallback={<div>Loading...</div>}>
          <FaceSearchListTable
            data={this.state.data}
            getAllocatedFaceSearchAllocationList={
              this.getAllocatedFaceSearchAllocationList
            }
          />
        </Suspense>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  const { pc_cities, basicDistricts } = professionals;
  return {
    user,
    users,
    pc_cities,
    basicDistricts,
  };
}

const connectedFaceSearchAllocation =
  connect(mapStateToProps)(FaceSearchAllocation);
export { connectedFaceSearchAllocation as FaceSearchAllocation };
